import React from 'react';

export const NoCartItem: React.FC = () => (
  <div className="flex items-center justify-center py-10">
    <p className="text-gray-500">Cart is empty, add items to continue.</p>
  </div>
);
